import { render, staticRenderFns } from "./TipsPremium.vue?vue&type=template&id=fc857286&scoped=true&"
import script from "./TipsPremium.vue?vue&type=script&lang=js&"
export * from "./TipsPremium.vue?vue&type=script&lang=js&"
import style0 from "./TipsPremium.vue?vue&type=style&index=0&id=fc857286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc857286",
  null
  
)

export default component.exports